import { KeywordGroupApiModel } from './keyword-group-api.model';
import { MediaTypeEnum } from '../../../Common/Basic/enums/media-type.enum';
import { LinkedinSubTypeEnum } from '../../../Common/Basic/enums/linkedin-sub-type.enum';
import { TwitterSubTypeEnum } from '../../../Common/Basic/enums/twitter-sub-type.enum';
import { BlueskySubTypeEnum } from '../../../Common/Basic/enums/bluesky-sub-type.enum';
import { BroadcastSubTypeEnum } from '../../../Common/Basic/enums/broadcast-sub-type.enum';
import { SearchCriteriaQueryIncludeExcludeModel } from './search-criteria-query-include-exclude.model';
import { SearchCriteriaDateQueryModel } from './search-criteria-date-query.model';
import { SentimentQueryModel } from './sentiment-query.model';
import { SearchCriteriaQueryIncludeExcludeGeographyModel } from './search-criteria-query-include-exclude-geography.model';
import { SearchCriteriaQueryIncludeExcludeSourcesModel } from './search-criteria-query-include-exclude-sources.model';
import { SearchCriteriaQueryRangeFilterModel } from './search-criteria-query-range-filter.model';
import { BasicNumberFilterModel } from './basic-number-filter.model';
import { AdvancedBooleanExpressionInterface } from './advanced-boolean-expression.interface';
import { BasicStringFilterModel } from './basic-string-filter.model';
import { ProminenceFilterApiModel, ProminenceRangeFilterApiModel } from './prominence-filter-api.model';
import { FilterSourceApiModel } from './filter-source-api.model';
import { SocialSearchRequestModel } from './social-search-request.model';
import { BasicFilterApiModel } from '../../shared/models/basic-filter.api.model';
import { SampleFilterApiModel } from './sample-filter-api.model';
import { DiscoverListFilterApiModel } from './discover-list-filter-api.model';
import { DrillDownTermFilterApi } from './drill-down-term-filter-api.model';

export class SearchCriteriaQueryModel {
    audienceReach: SearchCriteriaQueryRangeFilterModel;
    caseSensitive: boolean;
    adValueUsd: SearchCriteriaQueryRangeFilterModel;
    folder: BasicNumberFilterModel;
    harvestedDate: SearchCriteriaDateQueryModel;

    /** @deprecated use {@link SearchCriteriaQueryModel.isArchivedMention} */
    savedDate: SearchCriteriaDateQueryModel;

    editedDate: SearchCriteriaDateQueryModel;
    isArchivedCriticalMention?: boolean;
    isArchivedMention?: boolean;
    publicationDate: SearchCriteriaDateQueryModel;
    keywordGroups: KeywordGroupApiModel[];
    advancedBooleanExpressionFilter: AdvancedBooleanExpressionInterface;
    language: SearchCriteriaQueryIncludeExcludeModel;

    /** @deprecated use {@link SearchCriteriaQueryModel.mediaTypeFilter} */
    mediaTypes: MediaTypeEnum[];
    mediaTypeFilter: BasicFilterApiModel<MediaTypeEnum>;
    /** @deprecated use {@link SearchCriteriaQueryModel.tweetTypeFilter} */
    tweetTypes: TwitterSubTypeEnum[];
    tweetTypeFilter: BasicFilterApiModel<TwitterSubTypeEnum>;
    linkedinTypeFilter: BasicFilterApiModel<LinkedinSubTypeEnum>;
    blueskyTypeFilter: BasicFilterApiModel<BlueskySubTypeEnum>;
    tvTypeFilter: BasicFilterApiModel<BroadcastSubTypeEnum>;

    sentiment: SentimentQueryModel;


    /** @deprecated use {@link SearchCriteriaQueryModel.hashtagFilter} */
    hashtags: string[];

    hashtagFilter: BasicStringFilterModel;
    engagementFilter: {
        engagementRate: SearchCriteriaQueryRangeFilterModel;
        engagementTotal: SearchCriteriaQueryRangeFilterModel;
        amplification: SearchCriteriaQueryRangeFilterModel;
        conversation: SearchCriteriaQueryRangeFilterModel;
        applause: SearchCriteriaQueryRangeFilterModel;
        view: SearchCriteriaQueryRangeFilterModel;
    };
    enableEngagementInsights: boolean;
    location: SearchCriteriaQueryIncludeExcludeGeographyModel;
    contact: SearchCriteriaQueryIncludeExcludeSourcesModel;
    outlet: SearchCriteriaQueryIncludeExcludeSourcesModel;
    tag: BasicNumberFilterModel;
    tagGroup: BasicNumberFilterModel;
    sourceGroup: BasicNumberFilterModel;
    agent: BasicNumberFilterModel;
    /** Curation agents that have acted on the mention */
    aiAgent: BasicNumberFilterModel;
    /** Sources those agents acted from */
    aiAgentSource: BasicNumberFilterModel;
    /** Ad hoc agent runs that have acted on the mention */
    aiAgentAdhoc: BasicNumberFilterModel;
    theme: BasicNumberFilterModel;

    subscription: BasicNumberFilterModel;
    filterSources: FilterSourceApiModel[];
    agentId: number;
    themeId: number;
    url: BasicStringFilterModel;
    hasVisualMedia?: boolean;

    /** @deprecated use {@link SearchCriteriaQueryModel.prominenceBasicFilter} */
    prominenceFilter: ProminenceFilterApiModel;

    prominenceBasicFilter: BasicFilterApiModel<ProminenceRangeFilterApiModel>;

    domainAuthority: SearchCriteriaQueryRangeFilterModel;


    socialSearchRequest: SocialSearchRequestModel;
    drillDownTermFilters: DrillDownTermFilterApi[];

    discoverListFilter: DiscoverListFilterApiModel;

    sampleFilter?: SampleFilterApiModel;

    syndicateIds?: BasicStringFilterModel;

    constructor() {
        this.harvestedDate = null;
        this.publicationDate = null;
        this.savedDate = null;
        this.editedDate = null;
        this.keywordGroups = [];
        this.advancedBooleanExpressionFilter = {
            areas: [],
            filter: ''
        } as AdvancedBooleanExpressionInterface;
        this.language = {
            include: [],
            exclude: []
        };
        this.mediaTypeFilter = {
            include:  [],
            exclude: []
        };
        this.tweetTypeFilter = {
            include: [],
            exclude: []
        };
        this.linkedinTypeFilter = {
            include: [],
            exclude: []
        };
        this.tvTypeFilter = {
            include: [],
            exclude: []
        };
        this.sentiment = null;
        this.location = {
            include: null,
            exclude: null
        };
        this.contact = {
            include:  [],
            exclude: []
        };
        this.outlet = {
            include: [],
            exclude: []
        };
        this.hashtagFilter = {
            include: [],
            exclude: []
        };
        this.url = {
            include: [],
            exclude: []
        };
        this.sourceGroup = {
            include: [],
            exclude: []
        };
        this.engagementFilter = {
            engagementRate: { max: 100, min: 0 },
            engagementTotal: { max: NaN, min: NaN },
            amplification: { max: NaN, min: NaN },
            conversation: { max: NaN, min: NaN },
            applause: { max: NaN, min: NaN },
            view: { max: NaN, min: NaN },
        };
        this.prominenceBasicFilter = {
            include: [],
            exclude: []
        };
    }
}
